import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaRadioGroup = Loadable({
  loader: () => import("./RadioGroup"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaRadioGroup;



// WEBPACK FOOTER //
// ./ecology9/wea-radio-group/index.js